export default "/images/71a61ace94e57b6e4a1371a6d85806e8.avif";